// FETCH ALL STYLE
export const FETCH_SKU_MASTER_DETAILS_REQUEST = 'FETCH_SKU_MASTER_DETAILS_REQUEST';
export const FETCH_SKU_MASTER_DETAILS_SUCCESS = 'FETCH_SKU_MASTER_DETAILS_SUCCESS';
export const FETCH_SKU_MASTER_DETAILS_FAILURE = 'FETCH_SKU_MASTER_DETAILS_FAILURE';

export const FETCH_SKU_MASTER_DETAILS_WITH_ID_REQUEST = 'FETCH_SKU_MASTER_DETAILS_WITH_ID_REQUEST';
export const FETCH_SKU_MASTER_DETAILS_WITH_ID_SUCCESS = 'FETCH_SKU_MASTER_DETAILS_WITH_ID_SUCCESS';
export const FETCH_SKU_MASTER_DETAILS_WITH_ID_FAILURE = 'FETCH_SKU_MASTER_DETAILS_WITH_ID_FAILURE';

// CREATE STYLE
export const CREATE_SKU_MASTER_DETAILS_REQUEST = 'CREATE_SKU_MASTER_DETAILS_REQUEST';
export const CREATE_SKU_MASTER_DETAILS_SUCCESS = 'CREATE_SKU_MASTER_DETAILS_SUCCESS';
export const CREATE_SKU_MASTER_DETAILS_FAILURE = 'CREATE_SKU_MASTER_DETAILS_FAILURE';

// UPDATE STYLE
export const UPDATE_SKU_MASTER_DETAILS_REQUEST = 'UPDATE_SKU_MASTER_DETAILS_REQUEST';
export const UPDATE_SKU_MASTER_DETAILS_SUCCESS = 'UPDATE_SKU_MASTER_DETAILS_SUCCESS';
export const UPDATE_SKU_MASTER_DETAILS_FAILURE = 'UPDATE_SKU_MASTER_DETAILS_FAILURE';

// FETCH SINGLE STATE OF STYLE
export const FETCH_SINGLE_SKU_MASTER_DETAILS_REQUEST = 'FETCH_SINGLE_SKU_MASTER_DETAILS_REQUEST';
export const FETCH_SINGLE_SKU_MASTER_DETAILS_SUCCESS = 'FETCH_SINGLE_SKU_MASTER_DETAILS_SUCCESS';
export const FETCH_SINGLE_SKU_MASTER_DETAILS_FAILURE = 'FETCH_SINGLE_SKU_MASTER_DETAILS_FAILURE';

// DELETE STYLE
export const DELETE_SKU_MASTER_DETAILS_REQUEST = 'DELETE_SKU_MASTER_DETAILS_REQUEST';
export const DELETE_SKU_MASTER_DETAILS_SUCCESS = 'DELETE_SKU_MASTER_DETAILS_SUCCESS';
export const DELETE_SKU_MASTER_DETAILS_FAILURE = 'DELETE_SKU_MASTER_DETAILS_FAILURE';

export const RESET_SKU_MASTER_DETAILS_INFO = 'RESET_SKU_MASTER_DETAILS_INFO';

export const CREATE_SKU_MASTER_DETAILS_FORM = 'CREATE_SKU_MASTER_DETAILS_FORM';

export const UPDATE_SKU_MASTER_DETAILS_FORM = 'UPDATE_SKU_MASTER_DETAILS_FORM';
